/* Imports */
import axios from "../api/api";
/* /Imports/ */

/* 
  Class: UserService
  Description: This class is responsible for users stuff.
*/
class UserService {
  /* 
    Obtain all users from the api.
  */
  getAllUsers() {
    return axios.get("api/users").then((response) => {
      return response.data;
    });
  }

  /* 
    Obtain single user from the api.
  */
  getUser(id) {
    return axios.get("api/users/" + id).then((response) => {
      return response.data;
    });
  }

  /* 
    Update certain user from the api.
  */
  updateUser(id, data) {
    return axios
      .post("api/administrator/users/" + id + "/update", data, {
        headers: {
          Authorization:
            "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  /* 
    Delete certain user from the api.
  */
  deleteUser(id) {
    return axios
      .delete("api/administrator/users/" + id + "/delete", {
        headers: {
          Authorization:
            "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
        },
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new UserService();